// Background IMG
// TODO: Substituir pela imagem adequada
$('#signup-page').backstretch('/images/loginBackground.jpg');

// Validação do formulário

var form = $('#form');

// Phone, CEP and Terms validation
$(document).ready(function () {
	$('#signup-page').backstretch('/images/loginBackground.jpg');	

	// Validate phone
	var varPhone = $('#phone').val();
	var telInput = $("#phone");
	var validPhone = $("#valid_phone");
	var phoneValid = $('#phone_valid');
	var checkPhoneFieldEnter = 0;

	// Mask CPF
	if (document.settings.language == 'pt-br') {
		$('.cpf').mask('999.999.999-99');
	} else if (document.settings.language == 'es') {
		$('.cpf').mask('99999999-9');
	}

	// Basic
	$('.dropify').dropify();

	// Used events
	var drEvent = $('#input-file-events').dropify();
	drEvent.on('dropify.beforeClear', function(event, element) {
		return confirm("Do you really want to delete \"" + element.file.name + "\" ?");
	});
	drEvent.on('dropify.afterClear', function(event, element) {
		alert('File deleted');
	});
	drEvent.on('dropify.errors', function(event, element) {
		console.log('Has Errors');
	});
	var drDestroy = $('#input-file-to-destroy').dropify();
	drDestroy = drDestroy.data('dropify')
	$('#toggleDropify').on('click', function(e) {
		e.preventDefault();
		if (drDestroy.isDropified()) {
			drDestroy.destroy();
		} else {
			drDestroy.init();
		}
	});
	$(gender).prop( "checked", true );

	if(terms_acepted == true){
		$('#accept_terms').iCheck('check');
	} else{
		$('#accept_terms').iCheck('uncheck');
	}
});

var $form = $('#form');

$form.submit(function() {
	$('#phone_number').val($('#phone').intlTelInput("getNumber"));
});

function validateTerms(o,f){
	var checkterm = document.getElementsByName("accept_terms");

	if(checkterm.checked == false) {
		alert('Please accept the terms');
		return false;
	}
return true;
}	

$("#cpf").change(function (){
if(validateCpf($('#cpf').val())==true){
	$("#register").removeAttr('disabled');
	$("#invalid-cpf").addClass("hide");
}else{
	$("#invalid-cpf").removeClass("hide");
	$("#register").attr('disabled', 'disabled');
}
});

function validateCpf(value){
	value = value.replace(/\D/g, '');
	if (value.length != 11 || value.match("/^{value[0]}{11}$/")) {
		return false;
	}

	for (var s = 10, n = 0, i = 0; s >= 2; n += value[i++] * s--);

	if (value[9] != (((n %= 11) < 2) ? 0 : 11 - n)) {
		return false;
	}

	for (var s = 11, n = 0, i = 0; s >= 2; n += value[i++] * s--);

	if (value[10] != (((n %= 11) < 2) ? 0 : 11 - n)) {
		return false;
	}
	if (value == '00000000000' || 
		value == '11111111111' || 
		value == '22222222222' || 
		value == '33333333333' || 
		value == '44444444444' || 
		value == '55555555555' || 
		value == '66666666666' || 
		value == '77777777777' || 
		value == '88888888888' || 
		value == '99999999999') 
		{
		return false;
	}
	return true;
}
	
// iCheck
$(function() {
	$('input').iCheck({
		checkboxClass: 'icheckbox_square-blue',
		radioClass: 'iradio_square-blue',
		increaseArea: '20%' // optional
	});
});